import { render, staticRenderFns } from "./IssueOverviewCards.vue?vue&type=template&id=0d643c8c&scoped=true"
import script from "./IssueOverviewCards.vue?vue&type=script&lang=ts"
export * from "./IssueOverviewCards.vue?vue&type=script&lang=ts"
import style0 from "./IssueOverviewCards.vue?vue&type=style&index=0&id=0d643c8c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d643c8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,StatCard: require('/app/components/Metrics/StatCard.vue').default,CustomizeWidgetsModal: require('/app/components/RepoOverview/CustomizeWidgets/CustomizeWidgetsModal.vue').default,StatSection: require('/app/components/Metrics/StatSection.vue').default})
